import { useEffect, useState } from 'react'

import { UNMISSABLE_SECTION_ID } from './UnmissableSection'

const DISTANCE_FROM_TOP = 116 // Considering ModalSearchMobileTabs

type TabsType = 'for-you' | 'unmissable'

const ModalSearchMobileTabs = ({
  modalSearchEl,
}: {
  modalSearchEl: HTMLDivElement | null
}) => {
  const [activeTab, setActiveTab] = useState<TabsType>('for-you')

  function handleClick(type: TabsType) {
    if (!modalSearchEl) {
      return
    }

    if (type === 'for-you') {
      modalSearchEl.scrollTo({
        top: 0,
        behavior: 'smooth',
      })

      return
    }

    scrollToUnmissableSection()
  }

  function scrollToUnmissableSection() {
    const unmissableElement = document.getElementById(UNMISSABLE_SECTION_ID)

    if (!unmissableElement || !modalSearchEl) {
      return
    }

    const unmissableElementFromTop = unmissableElement.offsetTop

    const extra =
      window.innerHeight - unmissableElement.offsetHeight - DISTANCE_FROM_TOP

    modalSearchEl.scrollTo({
      top: unmissableElementFromTop + extra,
      behavior: 'smooth',
    })
  }

  useEffect(() => {
    const unmissableElement = document.getElementById(UNMISSABLE_SECTION_ID)
    const unmissableElementFromTop = unmissableElement?.offsetTop

    if (!unmissableElement || !modalSearchEl) {
      return undefined
    }

    const extra =
      window.innerHeight - unmissableElement.offsetHeight - DISTANCE_FROM_TOP

    modalSearchEl.style.paddingBottom = `${extra}px`

    const handleScroll = () => {
      if (!modalSearchEl) {
        return
      }

      if (
        modalSearchEl?.scrollTop >
        (unmissableElementFromTop! - DISTANCE_FROM_TOP) / 2
      ) {
        setActiveTab('unmissable')

        return
      }

      setActiveTab('for-you')
    }

    modalSearchEl?.addEventListener('scroll', handleScroll)

    return () => {
      modalSearchEl?.removeEventListener('scroll', handleScroll)
      modalSearchEl.style.paddingBottom = `0`
    }
  }, [modalSearchEl])

  return (
    <div className="flex sticky top-0 mt-2 w-[calc(100%+2rem)] -ml-4 font-inter font-medium bg-white z-50">
      <button
        onClick={() => handleClick('for-you')}
        className={`py-4 flex-1  ${
          activeTab === 'for-you'
            ? 'border-b-[3px] border-restructure-background-blue text-primaryBlue'
            : 'border-b border-gray text-tertiary'
        }`}
      >
        Para você
      </button>
      <button
        onClick={() => handleClick('unmissable')}
        className={`py-4 flex-1  ${
          activeTab === 'unmissable'
            ? 'border-b-[3px] border-restructure-background-blue text-primaryBlue'
            : 'border-b border-gray text-tertiary'
        }`}
      >
        Imperdível
      </button>
    </div>
  )
}

export default ModalSearchMobileTabs
